<script>
import GmapMap from 'gmap-vue/dist/esm/components/map-layer.vue'
import address from '@/modules/mixins/address'

export default {
    name: 'InputMap',

    components: {
        GmapMap,
    },

    mixins: [address],

    props: {
        value: {
            type: Object,
            default: () => {},
        },
        zoom: Boolean,
        draggable: Boolean,
        typeControl: Boolean,
        tooltip: String,
        height: {
            type: String,
            default: '200px',
        },
        mapZoom: {
            type: Number,
            default: 16,
        },
    },

    data() {
        return {
            centerCoordinates: null,
            dragging: false,
            mapOptions: {
                fullscreenControl: false,
                mapTypeControl: this.typeControl,
                streetViewControl: false,
                scaleControl: false,
                rotateControl: false,
                panControl: false,
                zoomControl: this.zoom,
                disableDoubleClickZoom: this.zoom,
                gestureHandling: this.draggable ? 'greedy' : 'none',
                clickableIcons: this.draggable,
                tilt: 0,
            },
        }
    },

    computed: {
        config() {
            return this.$store.getters['site/config']
        },
        center() {
            if (this.value && this.value.longitude && this.value.latitude)
                return {
                    lat: this.value.latitude,
                    lng: this.value.longitude,
                }
            return {
                lat: this.config.default_map_lat,
                lng: this.config.default_map_lng,
            }
        },
    },

    methods: {
        zoomChanged(zoom) {
            if (zoom >= 0) this.$refs.map.panTo(this.center)
        },
        updateCenter(latLng) {
            if (this.dragging) {
                this.centerCoordinates = latLng
            }
        },
        async sync() {
            if (this.centerCoordinates) {
                let result = await this.getAddress(
                    this.getCoordinates(this.centerCoordinates.lat(), this.centerCoordinates.lng())
                )
                result.geometry.location = this.centerCoordinates
                this.placeChanged(result)
                this.centerCoordinates = null
            }
        },
    },
}
</script>

<template lang="pug">
.input-map(:style="`height: ${height}`")
    gmap-map(
        ref="map"
        :options="mapOptions"
        :center="center"
        :zoom="mapZoom"
        @center_changed="updateCenter"
        @idle="sync"
        @dragstart="dragging = true"
        @dragend="dragging = false"
        @zoom_changed="zoomChanged"
        :style="`width: 100%; height: ${height}`"
    )
        template(v-slot:visible)
            .center-pin
                transition(name="fade")
                    .map-tooltip(v-if="!dragging && tooltip") {{tooltip}}
                //- img(src="/images/marker.svg")
                .input-map-marker                    
                    icon.text-white(icon="fa-solid fa-house" size="lg")
</template>
<style lang="scss" scoped></style>
